import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const updateFileMetadata = ({
                                     shumaId,
                                     fileID,
                                     freeText,
                                     freeID,
}) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    fileID: parseInt(fileID, 10),
    freeText,
    freeID: parseInt(freeID, 10),
  };

  return axios.post(api.UPDATE_FILE_METADATA, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);
    });
};
